import { z } from 'zod'

import { existingStrategyValuesSchema } from '../shared/strategy-values.schema'

export const createStrategySchema = (strategyTypes: string[]) =>
  existingStrategyValuesSchema(strategyTypes).extend({
    currency_id: z
      .string()
      .regex(/^[1-9]\d*$/, 'Select a currency')
      .refine((value) => Number.isSafeInteger(Number(value)), 'Select a valid currency'),
  })
export type CreateStrategyValues = z.infer<ReturnType<typeof createStrategySchema>>
